import { atom } from "recoil";

export const defaultFindPasswordFormState = {
    usrId : "",
    usrEmlAddr : "",
    isLcm: false
};
const findPasswordFormState = atom<{
    usrId: string;
    usrEmlAddr: string;
    isLcm: boolean;
}>({
    key: "findPasswordFormState",
    default: defaultFindPasswordFormState,
});

export default findPasswordFormState;
